import { inject, Injectable } from '@angular/core';
import { PasswordRepository } from '../repositories/password.repository';
import { UserValidationInfo } from '../data/user-validation';
import { ResetPassword } from '../data/reset-password';

@Injectable()
export class PasswordService {
  readonly #passwordRepository = inject(PasswordRepository);

  async requestToken(value: UserValidationInfo): Promise<UserValidationInfo> {
    return await this.#passwordRepository.requestToken(value);
  }

  async resetPassword(value: ResetPassword): Promise<boolean> {
    try {
      await this.#passwordRepository.resetPassword(value);
      return true;
    } catch {
      return false;
    }
  }
}
